module.exports = __webpack_public_path__ + "Employer Notice 06_10_2024.pdf";